import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import Amplify, { Interactions, Analytics } from "aws-amplify";
import AWS from "aws-sdk";
import * as LexModelBuildingService from "aws-sdk/clients/lexmodelbuildingservice";
// import config from "./config_prod";
import App from "./components/App";
import reducers from "./redux/reducers";
import { EVInteractionProvider } from "./layouts/Dashboard/components/Chat/components/EVInteractionProvider";
import { amplifyConfig } from "./amplifyConfig";
import {getEnvironmentName} from "./utils"
const environment = getEnvironmentName()

const config = require("app_configuration").CONFIGURATION[environment];

AWS.config.region = config.AWS_REGION;

Amplify.configure(amplifyConfig);

// Amplify.Logger.LOG_LEVEL = "VERBOSE";

Interactions.addPluggable(new EVInteractionProvider());

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

function noop() {}

if (["development", "deleteme", "qa"].indexOf(environment) < 0) {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
